import { useEffect, useState } from "react";
import { SpecIcon, MoedaFormatada } from "./assets/_ImvCardAssets";
import { BedroomIcon, BathroomIcon } from "./assets/ImvIcons";
import { ImvCarousel, ImvThumb } from "./Home/_imvImagesCarousel";
import '../static/css/Imv.css'


//* Monta o Card Recebendo os dados do imovel, em seguida realiza requisições adicionais para obter as imagens referentes

const ImvCard = ({ imv, onOpen }) => {
    const [card, setCard] = useState(document.querySelector('#imv_' + imv.id))
    const [imageUrls, setImageUrls] = useState([]);

    const cardClasses = `
        bg-gradient-to-b from-[#1d4aa7] from-60% to-[#3060C5]
        rounded-xl
        md:h-auto
        aspect-[5/4]
        shadow
        max-md:
        max-md:
        shadow-md
        transition
        hover:cursor-pointer 
        hover:bg-white
    `;


    // Mobile Ready
    return (
        // Exibição de Imovel Em Card Simples, com poucas informaçoes relevantes
        <article id={'imv_' + imv.id} key={imv.id} className={cardClasses} onClick={() => onOpen(imv)}
        >
            {/* <div className="w-screen h-screen bg-[#0004] fixed top-0 z-0"></div> */}

            <header className="w-full aspect-video bg-[#ffffff13] shadow-md rounded-xl">
                <ImvThumb nreg={imv.nreg} />
            </header>

            <main className="md:p-0 md:pt-2 h-auto m-0 max-md:p-3 max-md:text-xs"

            >
                <article className="flex flex-col space-y-4 justify-evenly md:font-[20pt] items-stretch max-md:gap-y-3 px-5 max-[420px]:px-1 py-2">
                    <p className="text-[8pt] text-[#c0c0c0] max-sm:text-[7pt]"> Nº: {imv.nreg} </p>

                    <div className="md:pt-0">
                        <h1 className="capitalize text-xl xl:text-[1rem]"> {imv.end} </h1>
                        <h1 className="capitalize text-xs"> {imv.bairro} </h1>
                    </div>

                    {/* Especificações com Icone */}
                    <section className="w-full self-end gap-4">
                        <div className="grid grid-flow-row gap-y-1  justify-between">
                            {/* Especificações Basicas */}
                            <span className="grid grid-flow-col items-center">
                                <SpecIcon icon={<BedroomIcon />} />
                                <h1> {imv.quartos} {imv.quartos > 1 ? 'Quartos' : 'Quarto'} </h1>
                            </span>
                            <span className="grid grid-flow-col items-center">
                                <SpecIcon icon={<BathroomIcon />} />
                                <h1> {imv.banheiros} {imv.banheiros > 1 ? 'Banheiros' : 'Banheiro'} </h1>
                            </span>
                        </div>

                    </section>

                    <footer className="">
                        <section className="w-full flex justify-between items-end max-sm:text-[10pt]">
                            <h2 className="xl:text-[1.3rem] capitalize font-thin rounded-full border py- px-5 border-blue-500"> {imv.tipo} </h2>
                            <h2> <MoedaFormatada valor={imv.preco} /> </h2>
                        </section>
                    </footer>
                </article>
            </main>

        </article>
    )
}
export default ImvCard;